export default "__VITE_ASSET__D729exz2__"